import { isUuid } from '@/mixins/utils'
import store from '@/store'

const detailsGuard = (
  action: 'user/getServiceRequest' | 'user/getContract',
) => async (to, from, next) => {
  const { hash } = to

  switch (true) {
    case Boolean(!store.getters['auth/isAuthenticated']()):
      next({ path: '/login', query: to.query })
      break

    case Boolean(hash && isUuid(hash.substring(1))):
      await store.dispatch(action, hash.substring(1))
      next()
      break

    default:
      next('/meine-alltagshelfer')
      break
  }
}

const SRDetailsGuard = detailsGuard('user/getServiceRequest')

const ContractDetailsGuard = detailsGuard('user/getContract')

export { SRDetailsGuard, ContractDetailsGuard }
